import type { FlagDefinition } from '@appd/fso-ui-shell/feature-flags';

export function createFlag(definition: FlagDefinition): FlagDefinition {
  return Object.freeze({
    defaultValue: definition.defaultValue,
    description: definition.description,
    remoteFlagName: definition.remoteFlagName ?? '',
  });
}
